module.exports = {
  sceneData: () => {
    return{
      "sinfin":{
        "name":"Estudio",
        "default" : true,
        "ambientLight" : {"color": 0xFFFFFF, "intensity": 1},
        "lightsOff": {"interiorToneMappingExposure": 0.6,"exteriorToneMappingExposure": 0.4, "interiorBloom":{"threshold": 2.7, "strength": 0.425, "radius": 3.2}, "exteriorBloom":{"threshold": 2.7, "strength": 0.425, "radius": 3.2} },
        "lightsOn": {"interiorToneMappingExposure": 1,"exteriorToneMappingExposure": 1, "interiorBloom":{"threshold": 0, "strength": 0, "radius": 0}, "exteriorBloom":{"threshold": 0, "strength": 0, "radius": 0} },
        "icon": require("./../UI/Scenes/Icon_sinfin.svg"),
        "hdr": './models/DOME_ASSETS/estudio/',
        "map":'./models/DOME_ASSETS/skydome.png'
      },
      "playa":{
        "name":"Playa",
        "default" : false,
        "ambientLight" : {"color": 0xFFFFFF, "intensity": 1},
        "lightsOff": {"interiorToneMappingExposure": 0.6,"exteriorToneMappingExposure": 0.4, "interiorBloom":{"threshold": 2.7, "strength": 0.425, "radius": 3.2}, "exteriorBloom":{"threshold": 2.7, "strength": 0.425, "radius": 3.2} },
        "lightsOn": {"interiorToneMappingExposure": 1,"exteriorToneMappingExposure": 1, "interiorBloom":{"threshold": 0, "strength": 0, "radius": 0}, "exteriorBloom":{"threshold": 0, "strength": 0, "radius": 0} },
        "icon": require("./../UI/Scenes/Icon_playa.svg"),
        "hdr": './models/DOME_ASSETS/playa/',
        "map":'./models/DOME_ASSETS/Playa.jpg'
      },
      "ciudad":{
        "name":"Ciudad",
        "default" : false,
        "ambientLight" : {"color": 0xFFFFFF, "intensity": 1},
        "lightsOff": {"interiorToneMappingExposure": 0.6,"exteriorToneMappingExposure": 0.325, "interiorBloom":{"threshold": 2.7, "strength": 0.425, "radius": 3.2}, "exteriorBloom":{"threshold": 2.7, "strength": 0.425, "radius": 3.2} },
        "lightsOn": {"interiorToneMappingExposure": 1,"exteriorToneMappingExposure": 1, "interiorBloom":{"threshold": 0, "strength": 0, "radius": 0}, "exteriorBloom":{"threshold": 0, "strength": 0, "radius": 0} },
        "icon": require("./../UI/Scenes/Icon_Ciudad.svg"),
        "hdr": './models/DOME_ASSETS/ciudad/',
        "map":'./models/DOME_ASSETS/Ciudad.jpg'
      },
      "campo":{
        "name":"Campo",
        "default" : false,
        "ambientLight" : {"color": 0xFFFFFF, "intensity": 1},
        "lightsOff": {"interiorToneMappingExposure": 0.6,"exteriorToneMappingExposure": 0.325, "interiorBloom":{"threshold": 2.7, "strength": 0.425, "radius": 3.2}, "exteriorBloom":{"threshold": 2.7, "strength": 0.425, "radius": 3.2} },
        "lightsOn": {"interiorToneMappingExposure": 1,"exteriorToneMappingExposure": 1, "interiorBloom":{"threshold": 0, "strength": 0, "radius": 0}, "exteriorBloom":{"threshold": 0, "strength": 0, "radius": 0} },
        "icon": require("./../UI/Scenes/Icon_Campo.svg"),
        "hdr": './models/DOME_ASSETS/campo/',
        "map":'./models/DOME_ASSETS/Campo.jpg'
      },
      "mall":{
        "name":"Mall",
        "default" : false,
        "ambientLight" : {"color": 0xFFFFFF, "intensity": 1},
        "lightsOff": {"interiorToneMappingExposure": 0.6,"exteriorToneMappingExposure": 0.4, "interiorBloom":{"threshold": 2.7, "strength": 0.425, "radius": 3.2}, "exteriorBloom":{"threshold": 2.7, "strength": 0.425, "radius": 3.2} },
        "lightsOn": {"interiorToneMappingExposure": 1,"exteriorToneMappingExposure": 1, "interiorBloom":{"threshold": 0, "strength": 0, "radius": 0}, "exteriorBloom":{"threshold": 0, "strength": 0, "radius": 0} },
        "icon": require("./../UI/Scenes/Icon_Mall.svg"),
        "hdr": './models/DOME_ASSETS/mall/',
        "map":'./models/DOME_ASSETS/Mall.jpg'
      },
      /*"calibracion":{
        "name":"Calibracion",
        "default" : false,
        "ambientLight" : {"color": 0xFFFFFF, "intensity": 1},
        "lightsOff": {"interiorToneMappingExposure": 0.6,"exteriorToneMappingExposure": 0.4, "interiorBloom":{"threshold": 2.7, "strength": 0.425, "radius": 3.2}, "exteriorBloom":{"threshold": 2.7, "strength": 0.425, "radius": 3.2} },
        "lightsOn": {"interiorToneMappingExposure": 1,"exteriorToneMappingExposure": 1, "interiorBloom":{"threshold": 0, "strength": 0, "radius": 0}, "exteriorBloom":{"threshold": 0, "strength": 0, "radius": 0} },
        "icon": require("./../UI/Scenes/Icon_Campo.svg"),
        "hdr": './models/DOME_ASSETS/calibracion/',
        "map":'./models/DOME_ASSETS/Calibracion.jpg'
      },*/
    }
  }
}